import { request } from '../../helpers/api/request';
import { FeedPropertyDefinitionsContract } from '../../types/Endpoints/feeds';

export const getFeedPropertyDefinitions = async () => {
    const { data } = await request<FeedPropertyDefinitionsContract>({
        url: 'admin/feeds/feed-property-definitions',
    });

    return data;
};
